import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showLoader, hideLoader } from "store/misc/loaderSlice";
import { showMessage } from "store/misc/messageSlice";
import trackingService from "services/trackingService";

export const findTracking = createAsyncThunk(
	"vino/tracking/list",
	async (order, { dispatch, rejectWithValue }) => {
		try {
			dispatch(showLoader());
			const results = await trackingService.find(order.id);
			return [
				{
					date: order.createdAt,
					derivedStatus: "Order placed",
				},
				...results,
			];
		} catch (err) {
			console.error(err);
			dispatch(
				showMessage({
					message: "Error occurred while getting shipping methods",
					variant: "error",
				})
			);
			return rejectWithValue(err.response.data);
		} finally {
			dispatch(hideLoader());
		}
	}
);

const trackingSlice = createSlice({
	name: "vino/tracking",
	initialState: {
		list: [],
		openTrackingDialog:false
	},
	reducers: {
		resetTracking: (state) => {
			state.list = [];
			state.openTrackingDialog = false
		},
		closeDialog: (state) => {
			state.openTrackingDialog = false 
		}
	},
	extraReducers: {
		[findTracking.fulfilled]: (state, action) => {
			state.list = action.payload;
			state.openTrackingDialog = true;
		},

	},
});

export const { closeDialog, resetTracking } = trackingSlice.actions;

export default trackingSlice.reducer;
